/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditTaskReportCommandResult } from '../../models/edit-task-report-command-result';

export interface ApiTaskEditTaskReportPut$Params {
      body?: {
'Id'?: string;
'Report'?: string;
'Attachments'?: Array<Blob>;
}
}

export function apiTaskEditTaskReportPut(http: HttpClient, rootUrl: string, params?: ApiTaskEditTaskReportPut$Params, context?: HttpContext): Observable<StrictHttpResponse<EditTaskReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskEditTaskReportPut.PATH, 'put');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditTaskReportCommandResult>;
    })
  );
}

apiTaskEditTaskReportPut.PATH = '/api/Task/EditTaskReport';
